// export const baseUrl = 'http://192.168.101.162:1029'
const baseUrl = 'https://zkao.app65.cn/'

module.exports = {
    baseUrl
}
